import {FC, useMemo} from 'react'
import {
  ContentDisappearingPhotoType,
  ContentDisappearingVideoType,
  ContentPhotoType,
  ContentTextType,
  ContentVideoType,
  DialogItemType,
  messageTypes
} from 'entities/messages'
import {mediaVariants} from 'shared/lib'
import {Gift, NoteSticky} from 'shared/ui/icons'
import styles from './styles.module.scss'

type ContentLastMessageProps = {
  dialog: DialogItemType
}

export const ContentLastMessage: FC<ContentLastMessageProps> = ({dialog}) => {
  const {lastMessage, interlocutor} = dialog

  return useMemo(() => {
    switch (lastMessage.type) {
    case messageTypes.text:
      return <div className={styles.text}>{(lastMessage.content as ContentTextType).text}</div>
    case messageTypes.photo:
      return <>
        <img src={(lastMessage.content as ContentPhotoType).photo.url + mediaVariants.square32} alt='preview' className={styles.img} />
        {lastMessage.to.id === interlocutor.id ? 'You sent' : 'Sent you'} a photo
      </>
    case messageTypes.video:
      return <>
        <img src={(lastMessage.content as ContentVideoType).video.jpgUrl} alt='preview' className={styles.img} />
        {lastMessage.to.id === interlocutor.id ? 'You sent' : 'Sent you'} a video
      </>
    case messageTypes.disappearingPhoto:
      return <>
        {(lastMessage.content as ContentDisappearingPhotoType)?.photo
          ? <img src={(lastMessage.content as ContentPhotoType).photo.url + mediaVariants.square32} alt='preview' className={styles.img} />
          : null}
        {lastMessage.to.id === interlocutor.id ? 'You sent' : 'Sent you'} a photo
      </>
    case messageTypes.disappearingVideo:
      return <>
        {(lastMessage.content as ContentDisappearingVideoType)?.video
          ? <img src={(lastMessage.content as ContentVideoType).video.jpgUrl} alt='preview' className={styles.img} />
          : null}
        {lastMessage.to.id === interlocutor.id ? 'You sent' : 'Sent you'} a video
      </>
    case messageTypes.sticker:
      return <>
        <div className={styles.stickerIcon}><NoteSticky /></div>
          Sticker
      </>
    case messageTypes.virtualGift:
      return <>
        <div className={styles.giftIcon}><Gift /></div>
        {lastMessage.to.id === interlocutor.id ? 'You sent' : 'Sent you'} a gift
      </>
    }
  }, [lastMessage, interlocutor])
}